import { makeService } from './api';

export default makeService('tenant_users');
